exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#suggestions{background-color:#f5f5f5;font-size:1.5rem;max-height:300px;overflow-x:hidden;overflow-y:auto}#suggestions ul{display:flex;flex-direction:column}#suggestions li{cursor:pointer;padding:5px 10px;text-align:left;-webkit-touch-callout:none;-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}#suggestions .focus{background-color:#dcdcdc}.height-enter-active,.height-leave-active{transition:max-height .25s}.height-enter,.height-leave-to{max-height:0!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b0e8890","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/suggestions.vue
// module id = 25
// module chunks = 0